import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function SwapCars({
  className,
  fillPrimary = colors.neutral100,
  fillSecondary = colors.aqua50,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M43.5 12.026L39 16.526L34.5 12.026"
        stroke={fillSecondary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 4.526C34.5913 4.526 36.1174 5.15814 37.2426 6.28336C38.3679 7.40858 39 8.9347 39 10.526V16.526"
        stroke={fillSecondary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 36.026L7.5 31.526L12 36.026"
        stroke={fillSecondary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 43.526C11.9087 43.526 10.3826 42.8939 9.25736 41.7686C8.13214 40.6434 7.5 39.1173 7.5 37.526V31.526"
        stroke={fillSecondary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7624 1H7.23758C6.83217 1.00007 6.43841 1.19885 6.11886 1.56477C5.79932 1.93068 5.57232 2.44273 5.47394 3.01956L4 9H24L22.5261 3.01956C22.4277 2.44273 22.2007 1.93068 21.8811 1.56477C21.5616 1.19885 21.1678 1.00007 20.7624 1Z"
        stroke={fillPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0769 19H2.92308C2.67826 19 2.44347 18.8683 2.27036 18.6339C2.09725 18.3995 2 18.0815 2 17.75V11.5C2 10.837 2.19451 10.2011 2.54073 9.73223C2.88695 9.26339 3.35652 9 3.84615 9H24.1538C24.6435 9 25.1131 9.26339 25.4593 9.73223C25.8055 10.2011 26 10.837 26 11.5V17.7583C25.9984 18.0884 25.9004 18.4042 25.7275 18.6368C25.5545 18.8695 25.3207 19 25.0769 19Z"
        stroke={fillPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="21.5" cy="13" r="1.5" fill={fillPrimary} />
      <circle cx="6.5" cy="13" r="1.5" fill={fillPrimary} />
      <rect x="10" y="11.5" width="1.5" height="5" rx="0.75" fill={fillPrimary} />
      <rect x="13.25" y="11.5" width="1.5" height="5" rx="0.75" fill={fillPrimary} />
      <path
        d="M16.5 12.25C16.5 11.8358 16.8358 11.5 17.25 11.5C17.6642 11.5 18 11.8358 18 12.25V15.75C18 16.1642 17.6642 16.5 17.25 16.5C16.8358 16.5 16.5 16.1642 16.5 15.75V12.25Z"
        fill={fillPrimary}
      />
      <mask id="path-12-inside-1_3259_9544" fill={colors.neutral100}>
        <path d="M3 20C3 19.4477 3.44772 19 4 19H8C8.55228 19 9 19.4477 9 20V23C9 24.1046 8.10457 25 7 25H5C3.89543 25 3 24.1046 3 23V20Z" />
      </mask>
      <path
        d="M3 20C3 19.4477 3.44772 19 4 19H8C8.55228 19 9 19.4477 9 20V23C9 24.1046 8.10457 25 7 25H5C3.89543 25 3 24.1046 3 23V20Z"
        stroke={fillPrimary}
        strokeWidth="3"
        mask="url(#path-12-inside-1_3259_9544)"
      />
      <mask id="path-13-inside-2_3259_9544" fill={colors.neutral100}>
        <path d="M19 20C19 19.4477 19.4477 19 20 19H24C24.5523 19 25 19.4477 25 20V23C25 24.1046 24.1046 25 23 25H21C19.8954 25 19 24.1046 19 23V20Z" />
      </mask>
      <path
        d="M19 20C19 19.4477 19.4477 19 20 19H24C24.5523 19 25 19.4477 25 20V23C25 24.1046 24.1046 25 23 25H21C19.8954 25 19 24.1046 19 23V20Z"
        stroke={fillPrimary}
        strokeWidth="3"
        mask="url(#path-13-inside-2_3259_9544)"
      />
      <g clipPath="url(#clip0_3259_9544)">
        <path
          d="M42.75 41C43.1478 41 43.5294 40.842 43.8107 40.5607C44.092 40.2794 44.25 39.8978 44.25 39.5V37.249C44.2497 36.7693 44.0591 36.3093 43.72 35.97L41.25 33.5H24.75L22.28 35.97C21.9409 36.3093 21.7503 36.7693 21.75 37.249V39.5C21.75 39.8978 21.908 40.2794 22.1893 40.5607C22.4706 40.842 22.8522 41 23.25 41H42.75Z"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.912 36.5H25.629C26.0265 36.5001 26.4078 36.658 26.689 36.939L27.75 38"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44.088 36.5H40.371C39.9735 36.5001 39.5922 36.658 39.311 36.939L38.25 38"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.75 33.5L26.45 28.96C26.6108 28.5307 26.899 28.1608 27.276 27.8999C27.6529 27.6389 28.1006 27.4994 28.559 27.5H37.441C37.8989 27.5 38.3459 27.6398 38.7223 27.9007C39.0986 28.1616 39.3863 28.5312 39.547 28.96L41.247 33.5H24.75Z"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.75 33.5L23.25 32H21.75"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.25 33.5L42.75 32H44.25"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.25 41V42.5C23.25 42.8978 23.408 43.2794 23.6893 43.5607C23.9706 43.842 24.3522 44 24.75 44C25.1478 44 25.5294 43.842 25.8107 43.5607C26.092 43.2794 26.25 42.8978 26.25 42.5V41H23.25Z"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.75 41V42.5C42.75 42.8978 42.592 43.2794 42.3107 43.5607C42.0294 43.842 41.6478 44 41.25 44C40.8522 44 40.4706 43.842 40.1893 43.5607C39.908 43.2794 39.75 42.8978 39.75 42.5V41H42.75Z"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3259_9544">
          <rect
            width="24"
            height="24"
            fill={colors.neutral100}
            transform="translate(21 24)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
